// @ts-ignore
import styles from './FilterForm.css';

import * as React from "react";
import {FilterFormProps, SelectedFilters} from "../Definitions";
import {SelectBox} from "./SelectBox";
import classNames from "classnames";

export const FilterForm = (props: FilterFormProps) => {
    const [inputs, setInputs] = React.useState<SelectedFilters>({
        countryId: "",
        topicId: "",
        startDate: "",
        endDate: "",
        withStartDateDeviation: true,
        withEndDateDeviation: true,
    });

    const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values, [name]: value}));

        if (name === "startDate") {
            const today = new Date();
            const startDate = new Date(value);
            if (startDate.getTime() >= today.getTime()) {
                if (inputs.endDate === null || inputs.endDate === "") {
                    setInputs(values => ({...values, endDate: value}));
                } else {
                    const endDate = new Date(inputs.endDate);

                    if (endDate.getTime() < startDate.getTime()) {
                        setInputs(values => ({...values, endDate: value}));
                    }
                }
            }
        }
    };

    const handleSelect = (id: string, type: string) => {
        if (type === 'countryId' || type === 'topicId') {
            setInputs(values => ({...values, [type]: id}));
        }
    }

    const handleFormSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        props.onChange(inputs);
    };

    const handleCheckbox = (identifier: string) => {
        const tmp = !inputs.withStartDateDeviation

        setInputs(
            values => ({
                ...values,
                withStartDateDeviation: tmp,
                withEndDateDeviation: tmp
            })
        );
    };

    return (
        <div>
            <form
                onSubmit={handleFormSubmit}
                className={styles.form}
            >

                <div
                    className={styles.filterFormRow}
                >
                    <div
                    >
                        <div
                            className={styles.filterFormRowHalf}
                        >
                            <label
                                className={classNames(
                                    styles.label
                                )}
                            >
                                Von:
                                <input
                                    name="startDate"
                                    type="date"
                                    value={inputs.startDate ?? ""}
                                    onChange={handleInput}
                                    className={styles.datePicker}
                                />
                            </label>

                            <label
                                className={classNames(
                                    styles.label
                                )}
                            >
                                Bis:
                                <input
                                    name="endDate"
                                    type="date"
                                    value={inputs.endDate ?? ""}
                                    onChange={handleInput}
                                    className={styles.datePicker}
                                />
                            </label>
                        </div>
                        <div>
                            <label
                                className={classNames(
                                    styles.deviationLabel
                                )}
                            >
                                <input
                                    name="withStartDateDeviation"
                                    type="checkbox"
                                    className={styles.checkbox}
                                    checked={inputs.withStartDateDeviation}
                                    onChange={
                                        () => handleCheckbox("withStartDateDeviation")
                                    }
                                />

                                <div>
                                    Die Reise kann um +/- 2 Tage verlegt werden
                                </div>
                            </label>
                        </div>
                    </div>

                    <div
                        className={styles.filterFormRowHalf}
                    >
                        <div>
                            <span className={styles.label}>
                                Reiseziel
                            </span>
                            <SelectBox
                                name={"countryId"}
                                emptyValue={"alle"}
                                options={props.countryOptions}
                                onChange={handleSelect}
                            />
                        </div>

                        <div>
                            <span className={styles.label}>
                                Reisethema
                            </span>
                            <SelectBox
                                name={"topicId"}
                                emptyValue={"alle"}
                                options={props.topicOptions}
                                onChange={handleSelect}
                            />
                        </div>
                    </div>
                </div>

                {
                    props.teaserText &&
                    <div
                        className={classNames(styles.filterFormRow, styles.teaserText)}
                    >
                        {props.teaserText}
                    </div>
                }

                <button
                    className={styles.btn}
                >
                    Suche Angebote
                    <i className="fa fa-bold fa-angle-double-right"></i>
                </button>
            </form>

        </div>
    );
}
